import React from 'react';

import { LoadableAfterPaint, LoadableBackground } from '@confluence/loadable';

import { ReactionsPlaceholder } from './ReactionsPlaceholder.tsx';
import { ReactionsSummaryViewPlaceholder } from './ReactionsSummaryViewPlaceholder.tsx';

export const ReactionsLoader = LoadableAfterPaint({
	loading: (props) => {
		return props?.summaryViewEnabled ? (
			<ReactionsSummaryViewPlaceholder />
		) : (
			<ReactionsPlaceholder useAccuratePills {...props} />
		);
	},
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Reactions" */ './Reactions.tsx')).Reactions,
});

export const ReactionsLoaderBackground = LoadableBackground({
	loading: (props) => {
		return props?.summaryViewEnabled ? (
			<ReactionsSummaryViewPlaceholder />
		) : (
			<ReactionsPlaceholder />
		);
	},
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Reactions" */ './Reactions.tsx')).Reactions,
});
